var map = {
	"./bee-brockwell.jpeg": 772,
	"./boxhill-view.JPG": 749,
	"./butterfly-montreal.JPG": 185,
	"./chief.jpeg": 192,
	"./cuba-rooftops.jpeg": 204,
	"./cuba-view.JPG": 266,
	"./inflight.jpeg": 206,
	"./mevagissey-harbour.jpeg": 666,
	"./monestry-malta.jpeg": 180,
	"./moon.jpeg": 298,
	"./osborne.jpeg": 765,
	"./parakeet-hernehill.jpeg": 268,
	"./rainbow-faroes.JPG": 120,
	"./statue-malta.jpeg": 871,
	"./sunset-brixton.JPG": 674,
	"./sunset-field.jpeg": 836,
	"./tower-birds-brockwell.jpeg": 319,
	"./waterfall-faroes.JPG": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;